(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RLoginEIP1193Provider", [], factory);
	else if(typeof exports === 'object')
		exports["RLoginEIP1193Provider"] = factory();
	else
		root["RLoginEIP1193Provider"] = factory();
})(this, function() {
return 